import { createContext, Dispatch, MutableRefObject, ReactNode, SetStateAction, useEffect, useRef, useState } from 'react'

import { WebSocketState } from '@/types/websocket'

export interface WebsocketContextProps {
  websocket: MutableRefObject<WebSocket | null>
  websocketState: WebSocketState
  setWebsocketState: Dispatch<SetStateAction<WebSocketState>>
}

export const WebsocketContext = createContext({} as WebsocketContextProps)

interface WebsocketProviderProps {
  children: ReactNode
}

export const WebsocketProvider = ({ children }: WebsocketProviderProps) => {
  const websocket = useRef<WebSocket | null>(null)
  const [websocketState, setWebsocketState] = useState<WebSocketState>(WebSocketState.CLOSED)

  useEffect(() => {
    return () => {
      websocket.current?.close()
      setWebsocketState(WebSocketState.CLOSED)
      websocket.current = null
    }
  }, [])

  const value = {
    websocket,
    websocketState,
    setWebsocketState
  }

  return <WebsocketContext.Provider value={value}>{children}</WebsocketContext.Provider>
}
